<template>
  <div class="y-scroll flex flex-column flex-ali-center" :style="style">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    padding: {
      default: 10
    }
  },
  data() {
    return {
      
    };
  },
  computed:{
    style(){
      return {
        padding: isNaN(this.padding) ? this.padding : `${this.padding}px`
      }
    }
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
.y-scroll{
  height: 100%;
  overflow: auto;
}
</style>
